// ! This file was auto-generated from the weaver OpenAPI schema. Do not override this file.
import { Tags } from "./tags.autogen";
export const endpoints = {
    createComment: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Comment, id: "LIST" }]
    },
    deleteComment: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Comment, id: "LIST" }]
    },
    getComments: {
        providesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Comment, id: "LIST" }]
    },
    resolveComment: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Comment, id: "LIST" }]
    },
    unresolveComment: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Comment, id: "LIST" }]
    },
    updateComment: {
        invalidatesTags: (_result: unknown, _error: unknown, _arg: any) => [{ type: Tags.Comment, id: "LIST" }]
    }
} as const;
